export enum Protocol {
  https = 'https:',
  http = 'http:'
}
